import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedin, FaMusic, FaYoutube, FaGlobe, FaSnapchatGhost } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const platforms = [
  { id: 'twitter', name: 'X', Icon: FaXTwitter, color: '#000000' },
  { id: 'facebook', name: 'Facebook', Icon: FaFacebook, color: '#1877F2' },
  { id: 'instagram', name: 'Instagram', Icon: FaInstagram, color: '#E4405F' },
  { id: 'snapchat', name: 'Snapchat', Icon: FaSnapchatGhost, color: '#FFFC00' },
  { id: 'linkedin', name: 'LinkedIn', Icon: FaLinkedin, color: '#0A66C2' },
  { id: 'tiktok', name: 'TikTok', Icon: FaMusic, color: '#000000' },
  { id: 'youtube', name: 'YouTube', Icon: FaYoutube, color: '#FF0000' }
];

const PlatformSelector = ({ selectedPlatforms, togglePlatform, selectAllPlatforms }) => (
  <div>
    <div className="flex items-center justify-between mb-2">
      <label className="text-sm text-gray-600">Cross-post to Platforms</label>
      <button
        type="button"
        onClick={selectAllPlatforms}
        className="flex items-center space-x-1 text-xs font-medium text-[#4A90E2] hover:text-[#3A80D2]"
        data-testid="select-all-platforms"
      >
        <FaGlobe size={12} />
        <span>{selectedPlatforms.length === platforms.length ? 'Deselect All' : 'Post Everywhere'}</span>
      </button>
    </div>
    <div className="grid grid-cols-3 gap-2">
      {platforms.map(({ id, name, Icon, color }) => (
        <button
          key={id}
          type="button"
          data-testid={`platform-${id}`}
          onClick={() => togglePlatform(id)}
          className={`p-3 rounded-lg border transition-all ${
            selectedPlatforms.includes(id)
              ? 'border-[#4A90E2] bg-[#4A90E2]/10'
              : 'border-gray-200 bg-gray-100 hover:bg-gray-200'
          }`}
        >
          <Icon className="text-xl mx-auto mb-1" style={{ color }} />
          <p className="text-xs text-gray-700 font-medium">{name}</p>
        </button>
      ))}
    </div>
  </div>
);

export { platforms };
export default PlatformSelector;
